import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { PathologyTO } from '../../lib';
import { InputGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import usePreferences from '../pages/Settings/hook/usePreferences';
import ObservationTableHeader from '../pages/DataAnnotation/components/ObservationTableHeader';
import ObservationTable from '../pages/DataAnnotation/components/ObservationTable';
import {
  ObservationTableHeaderViewModeEnum,
  transformObservationHeaders,
  transformObservationValues,
} from '../pages/DataAnnotation/utils';
import { useGlobalLoading } from '../../context';

export const PathologyTimelineTable = ({
  requestRefresh,
}: {
  requestRefresh: () => void;
}) => {
  const { hiddenPathologies } = useSelector(
    (state: RootState) => state.preferences,
  );

  const { observationTable } = useSelector(
    (state: RootState) => state.timeline,
  );

  const { startLoading, stopLoading } = useGlobalLoading();

  const { updatePathologyPreferences } = usePreferences();

  const pathologyItems = Object.keys(observationTable).map((item, index) => {
    return {
      id: item.toLowerCase().trim() + index,
      name: item,
    };
  });

  const defaultData = (pathologyItems || []).reduce(
    (acc, curr) => {
      acc[curr.id] = !hiddenPathologies?.includes(curr.name);
      return acc;
    },
    {} as Record<string, boolean>,
  );

  const { register, getValues, watch, setValue } = useForm({
    defaultValues: defaultData,
  });

  const observationHeaders = transformObservationHeaders(
    observationTable,
    new Date().toISOString(),
    ObservationTableHeaderViewModeEnum.PATIENT_DETAILS,
  );
  const observationValues = transformObservationValues(
    observationTable,
    undefined,
    ObservationTableHeaderViewModeEnum.PATIENT_DETAILS,
  );
  const havingData = observationValues.length > 0;

  const updateUserPathologyPreferences = async () => {
    const selectedPathologies = getValues();
    const hiddenPathologiesKeys = Object.keys(selectedPathologies).filter(
      (key) =>
        selectedPathologies[key as keyof typeof selectedPathologies] === false,
    );
    const hiddenPathologiesNames = hiddenPathologiesKeys.reduce(
      (acc: string[], key) => {
        const item = pathologyItems.find((item) => item.id === key);
        if (item?.name) {
          return [...acc, item.name];
        }
        return acc;
      },
      [],
    );
    startLoading();
    await updatePathologyPreferences(hiddenPathologiesNames);
    await requestRefresh();
    stopLoading();
  };

  return (
    <div className="pathology-timeline-table-container">
      <table>
        <thead>
          <tr>
            <th
              scope="col"
              style={{ width: '50px' }}
              className="font-weight-700 roboto font-13 text-center d-flex align-items-center"
            >
              Show on timeline
            </th>
            {/* <th scope="col" style={{ paddingLeft: '15px' }}>
              Pathology result
            </th> */}
          </tr>
        </thead>
        <tbody>
          {pathologyItems?.map((pathology: PathologyTO) => {
            return (
              <tr>
                <th
                  style={{ textAlign: 'center', marginRight: '10px' }}
                  scope="row"
                >
                  <InputGroup.Checkbox
                    {...register(pathology.id)}
                    checked={watch(pathology.id)}
                    style={{ border: 0 }}
                    onChange={(e) => {
                      setValue(e.target.name, e.target.checked);
                      updateUserPathologyPreferences();
                    }}
                  />
                </th>
                {/* <td style={{ width: '120px', paddingLeft: '15px' }}>
                  {pathology.name}
                </td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div style={{ width: '85%' }}>
        <ObservationTableHeader headerData={observationHeaders} />
        {havingData ? (
          <>
            <ObservationTable observationData={observationValues} />
          </>
        ) : (
          <span className="roboto font-12">
            No observation results for the current episode
          </span>
        )}
      </div>
    </div>
  );
};
